var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamcorderAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88491 7.49833C8.47664 7.49833 8.95633 7.01863 8.95633 6.4269C8.95633 5.83516 8.47664 5.35547 7.88491 5.35547C7.29317 5.35547 6.81348 5.83516 6.81348 6.4269C6.81348 7.01863 7.29317 7.49833 7.88491 7.49833Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7776 1.07031H1.99191C1.08119 1.07031 0.384766 1.76674 0.384766 2.67746V10.1775C0.384766 11.0882 1.08119 11.7846 1.99191 11.7846H4.56334L4.08119 12.3739C3.70619 12.856 3.59905 13.4989 3.86691 14.0882C4.13477 14.6239 4.72405 14.9989 5.31334 14.9989H10.4026C11.0455 14.9989 11.5812 14.6239 11.8491 14.0882C12.1169 13.4989 12.0098 12.856 11.6348 12.3739L11.2062 11.7846H13.7776C14.6883 11.7846 15.3848 11.0882 15.3848 10.1775V2.67746C15.3848 1.76674 14.6883 1.07031 13.7776 1.07031ZM7.88477 9.64174C6.11691 9.64174 4.67048 8.19531 4.67048 6.42745C4.67048 4.6596 6.11691 3.21317 7.88477 3.21317C9.65262 3.21317 11.0991 4.6596 11.0991 6.42745C11.0991 8.19531 9.65262 9.64174 7.88477 9.64174ZM12.7062 4.2846H11.6348C11.3133 4.2846 11.0991 4.07031 11.0991 3.74888C11.0991 3.42746 11.3133 3.21317 11.6348 3.21317H12.7062C13.0276 3.21317 13.2419 3.42746 13.2419 3.74888C13.2419 4.07031 13.0276 4.2846 12.7062 4.2846Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamcorderAvailable);
export default __webpack_public_path__ + "static/media/icon-camcorder-available.2739645a065133e37a4deb693b3e53c0.svg";
export { ForwardRef as ReactComponent };